
<template>
  <Modal
    :id="'cmp-royalty_accounts-edit_royalty_statement'"
    @cancelled="onCancel"
  >
    <template slot="header">
      {{ $t("royalty_statement") }}
      {{ selectedRpPayment.royalty_account_name
      }}{{
        selectedRpPayment.royalty_period_text
          ? " - " + selectedRpPayment.royalty_period_text
          : ""
      }}
    </template>
    <template slot="body">
      <div class="form-group">
        <TextField
          :id="'payment_date'"
          class="m1"
          v-bind="textFieldConfig"
          type="date"
          :value="selectedPayment.payment_date"
          :placeholder="$t('payment_date')"
          @valuechanged="onTextFieldValueChange"
          canReset
        />
        <TextField
          :id="'payment_amount'"
          class="m1"
          v-bind="textFieldConfig"
          :value="selectedPayment.payment_amount"
          :placeholder="$t('payment_amount')"
          @valuechanged="onTextFieldValueChange"
        />
        <Dropdown
          :id="'payment_method'"
          class="m2"
          :options="payment_methodsTV"
          :selected="
            payment_methodsTV.find(
              (b) => b.value == selectedPayment.payment_method
            )
          "
          :placeholder="$t('payment_method')"
          deselect
          box
          @selectedChange="(b) => onDropdownChange('payment_method', b)"
        ></Dropdown>
        <TextField
          :id="'payment_reference'"
          class="m1"
          v-bind="textFieldConfig"
          :value="selectedPayment.payment_reference"
          :placeholder="$t('payment_reference')"
          @valuechanged="onTextFieldValueChange"
        />
        <TextField
          :id="'notes'"
          class="m1"
          v-bind="textFieldConfig"
          :value="selectedPayment.notes"
          :placeholder="$t('notes')"
          @valuechanged="onTextFieldValueChange"
        />
        <Dropdown
          v-if="display_currency"
          :id="'display_currency'"
          class="m2"
          :options="currenciesTV"
          :selected="
            currenciesTV.find(
              (b) => b.value == selectedPayment.display_currency
            )
          "
          :placeholder="$t('display_currency')"
          deselect
          box
          @selectedChange="(b) => onDropdownChange('display_currency', b)"
        ></Dropdown>
        <TextField
          v-if="display_currency"
          :disabled="true"
          :id="'exchange_rate'"
          class="m1"
          v-bind="textFieldConfig"
          :value="selectedPayment.exchange_rate"
          :placeholder="$t('exchange_rate')"
          @valuechanged="onTextFieldValueChange"
        />
      </div>
    </template>
    <template slot="options">
      <button class="dt-button s6" @click.stop="onCancel">
        {{ $t("cancel") }}
      </button>
      <button
        :disabled="!okButtonValid"
        :class="{ disabled: !okButtonValid }"
        class="dt-button v1 s6"
        @click.stop="onAdd"
      >
        {{ $dft.snakeCaseToWords($t("ok")) }}
      </button>
    </template>
  </Modal>
</template>
  
<script>
import Modal from "../../../../dt-plugins/modal/modal";
import { openModalRoute } from "../../../../dt-plugins/modal/modal.mixin";
import { AccountsService } from "../../services/accounts.service";
import { createTV } from "../../../../models/text-value.model";
import { EventHooks } from "../../../../plugins/text-field";
export default {
  components: {
    Modal,
  },
  props: ["selectedRpPayment"],
  data: () => ({
    loading: false,
    rpData: null,
    selectedPayment: {
      payment_date: "",
      payment_method: "",
      payment_reference: "",
      payment_amount: "",
      notes: "",
      exchange_rate: "",
      display_currency: "",
    },
    validationResult: {},
    textFieldConfig: {
      height: 42,
      showEditIconOnHover: false,
      box: true,
    },
  }),

  mounted: async function () {
    this.loading = true;
    const res = await AccountsService.RPpaymentinfomodaldata(
      this.royalty_period_id
    );
    this.rpData = res.data.modal_data;

    this.loading = false;
    
    if (this.selectedRpPayment.json_data) {
      this.selectedPayment = {
        ...JSON.parse(this.selectedRpPayment.json_data),
      };
    }
  },
  computed: {
    royalty_period_id: function () {
      return this.$route.query.royalty_period_id;
    },
    okButtonValid() {
      return this.isFormValid && !this.loading;
    },
    isFormValid: function () {
      return Object.values(this.validationResult).every((e) => e.valid);
    },
    currenciesTV: function () {
      return createTV(this.rpData?.currencies, "currency_iso", "currency_id");
    },
    payment_methodsTV: function () {
      return createTV(
        this.rpData?.payment_methods,
        "payment_method_name",
        "payment_method_id"
      );
    },

    display_currency: function () {
      return this.rpData?.display_currency || false;
    },
  },
  methods: {
    onValidation: function (name, value) {
      this.$set(this.validationResult, name, value);
    },

    onAdd: async function () {
      this.loading = true;
      const res = await AccountsService.saveRPpaymentdata({
        rpModelData: { ...this.selectedPayment },
        royalty_period_id: this.royalty_period_id,
      });
      this.$emit("edited", {
        royalty_period_id: this.royalty_period_id,
        json_data: JSON.stringify(this.selectedPayment),
      });
    },

    onTextFieldValueChange(name, value) {
      console.log({ name, value });
      this.selectedPayment[name] = value;
    },

    onDropdownChange(name, value) {
      console.log({ name, value });
      if (name === "display_currency") {
        const currency = this.rpData?.currencies.find(
          (c) => c.currency_id === value.value
        );
        this.selectedPayment.exchange_rate = currency
          ? currency.exchange_rate
          : "";
      }
      this.selectedPayment[name] = value.value;
      console.log({ ...this.selectedPayment });
    },
    onCancel: function () {
      this.$emit("cancelled", true);
    },
  },
};
</script>
  
<style lang="scss" >
.cmp-royalty_accounts-edit_royalty_statement {
  .dropdown--item .dropdown--item--text {
    text-transform: uppercase !important;
  }

  .body-container {
    max-height: 460px;
    padding-right: 30px;
    overflow: hidden;
    overflow-y: auto;
    width: 100%;

    .dt-modal--subtitle {
      &:first-child {
        margin-top: 0;
      }
    }
  }

  .dt-checkbox-control {
    align-items: center;
    height: 32px;

    .dt-checkbox-label {
      flex: 1;
      padding-left: 10px;
    }
  }

  .item-container {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;

    .s6 {
      margin: 10px;
    }
  }

  .dt-modal--options {
    button {
      &:first-child {
        margin-right: 10px;
      }

      &:last-child {
        margin-left: 0px 10px;
      }
    }
  }

  .btn-deduction {
    text-transform: uppercase;
    max-width: 250px;
    min-width: 250px;
    height: 30px;
    margin: 5px;
    border-radius: 12px;
  }
}
</style>
  